import { useQuery } from "react-query";
import { db } from '../../constants/firebase'

const getLocations = () => {
    return db.collection("locations")
        .orderBy("name")
        .get()
        .then((res) => {
            return res.docs.map(doc => {
                const uid = { "uid": doc.id }
                const data = doc.data()
                return Object.assign({}, uid, { ...data })
            })
        })
}

const useLocations = () => {
    return useQuery({
        queryKey: "locations",
        queryFn: getLocations,
        refetchOnWindowFocus: false,
        //query will autoFetch after 15 minutes:
        staleTime: 900000,
    })
}

export { useLocations }
